import { useGlobalStore } from "~/stores/global";

export const useBlogLocale = (site) => computed(() => toValue(site)?.split("-").at(0) || "en");

export const useCurrentCountryData = () => {
  const { locale } = useI18n();
  const globalStore = useGlobalStore();
  const allSites = globalStore.siteAllLocales;

  const countryCode = computed(() => {
    // Extract "US" from "en-US"
    return locale.value.split("-")[1] || null;
  });

  const countryData = computed(() => {
    if (!countryCode.value) return null;
    return allSites?.[countryCode.value.toUpperCase()] || null;
  });

  return {
    countryCode,
    countryData,
  };
};
